exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-title[data-v-d7d9ff64]{font-weight:800}.mobile-input[data-v-d7d9ff64]{border-top:0!important;border-left:0!important;border-right:0!important}.info-text[data-v-d7d9ff64]{font-size:14px;white-space:pre-wrap}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d7d9ff64","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GuestDetails.vue
// module id = Ehyg
// module chunks = 0